import { render } from "./ThreeTimesExplanation.vue?vue&type=template&id=35ba8230&scoped=true"
const script = {}

import "./ThreeTimesExplanation.vue?vue&type=style&index=0&id=35ba8230&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35ba8230"]])

export default __exports__